import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  getRangeOptions,
  getSelectedRangeOption,
  getDateRanges,
  addAllTime,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_DATES,
  UPDATE_DATES,
  FETCH_TABLE_DATA_SUCCESS,
  SET_TABLES_LOADING,
  SET_REFERRAL_TABLE_LOADING,
  FETCH_FUNNEL_CHART_SUCCESS,
  RESET_REFERRAL_TABLE,
  UPDATE_CUSTOM_RANGE,
  SET_START_FROM,
  SET_START_FROM_APPOINTMENT,
  ADD_ALL_TIME_RANGE_SUCCESS,
  FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS,
  SET_TOGGLE_LOOSE,
  SET_TOGGLE_FUTURE_APPOINTMENT,
  SET_TOGGLE_REFERRAL_CATEGORY,
  FETCH_REFERRAL_TABLE_SUCCESS,
  SET_SHOW_FUTURE_APPOINTMENT,
  SET_AVERAGE,
  FETCH_SUB_AVERAGE_FILTERS_SUCCESS,
  SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS,
  SET_AVERAGE_TOOLTIP
} from "../sagas/funnelChart/funnelChart";
import FUNNEL_CONSTANTS from "../../constants";

// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  SET_DATES,
  UPDATE_DATES,
  FETCH_TABLE_DATA_SUCCESS,
  SET_TABLES_LOADING,
  FETCH_FUNNEL_CHART_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  SET_START_FROM_APPOINTMENT,
  ADD_ALL_TIME_RANGE_SUCCESS,
  SET_TOGGLE_LOOSE,
  SET_TOGGLE_FUTURE_APPOINTMENT,
  FETCH_REFERRAL_TABLE_SUCCESS,
  SET_SHOW_FUTURE_APPOINTMENT
};

const initialState = {
  isLoading: true,
  currentUser: {},
  selectedRequestDates: {},
  tablesLoading: false,
  referralTableLoading: false,
  haveRequestError: false,
  startFromAppointment: false,
  startFromLead: false,
  startFrom: FUNNEL_CONSTANTS.START_FROM_OPTIONS.LEAD,
  average: FUNNEL_CONSTANTS.AVERAGE_OPTIONS[0],
  subAverageFilterOptions: {},
  selectedSubAverageFilterOptions: [],
  averageTooltip: "",
  isIntroOfferSelected: false,
  toggleLoose: false,
  toggleFutureAppointment: false,
  toggleReferralCategory: true,
  requestError: {},
  isLeadSelected: false,
  averageIsNotSelected: true,
  funnelChartData: {
    funnel_laser: {
      total: { value: 0, url: "" },
      chart: {},
      totalLabel: "",
      totalRawDataLink: "",
      title: "",
      values: [],
      hideAverageDaysToConversion: true,
      averageDaysToAppointment: {}
    }
  },
  funnelIntroOffers: {
    primaryStats: [],
    secondaryStats: [],
    combinedStats: [],
    chart: {
      label: "",
      data: {
        values: []
      }
    }
  },
  funnelLaser: {},
  referralTable: {
    referrals_table: {
      tableInfo: {
        data: []
      }
    }
  },
  selectedRangeOption: getSelectedRangeOption(),
  rangeOptions: getRangeOptions(),
  canUseCurrentMonth: null
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload,
      haveRequestError: false
    }),
    [SET_START_FROM]: (state, action) => ({
      ...state,
      filtersDirty: true,
      startFrom: action.payload
    }),
    [SET_AVERAGE]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      average: payload,
      selectedSubAverageFilterOptions: state.subAverageFilterOptions[payload] || []
    }),
    [SET_AVERAGE_TOOLTIP]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      averageTooltip: payload
    }),
    [SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedSubAverageFilterOptions: payload
    }),
    [SET_START_FROM_APPOINTMENT]: (state, action) => ({
      ...state,
      startFromAppointment: action.payload
    }),
    [SET_SHOW_FUTURE_APPOINTMENT]: (state, action) => ({
      ...state,
      toggleFutureAppointment: action.payload
    }),
    [SET_TOGGLE_LOOSE]: (state, action) => ({
      ...state,
      toggleLoose: action.payload
    }),
    [SET_TOGGLE_FUTURE_APPOINTMENT]: (state, action) => ({
      ...state,
      toggleFutureAppointment: action.payload
    }),
    [SET_TOGGLE_REFERRAL_CATEGORY]: (state, action) => ({
      ...state,
      toggleReferralCategory: action.payload
    }),
    [SET_TABLES_LOADING]: (state, action) => ({
      ...state,
      tablesLoading: action.payload
    }),
    [SET_REFERRAL_TABLE_LOADING]: (state, action) => ({
      ...state,
      referralTableLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.funnelChartData.first_data_date
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => {
      const currentUser = action.payload.params || state.currentUser;

      return {
        ...state,
        currentUser,
        filtersDirty: false,
        rangeOptions: getRangeOptions(currentUser.calendarEndDate),
        selectedRangeOption: getSelectedRangeOption(currentUser.calendarEndDate)
      };
    },
    [RESET_REFERRAL_TABLE]: (state) => ({
      ...state,
      referralTable: {
        referrals_table: {
          tableInfo: {
            data: []
          }
        }
      },
      isLeadSelected: false,
      toggleReferralCategory: initialState.toggleReferralCategory
    }),
    [FETCH_FUNNEL_CHART_SUCCESS]: (state, action) => ({
      ...state,
      filtersDirty: false,
      isIntroOfferSelected: false,
      funnelChartData: action.payload,
      funnelLaser: action.payload.funnel_laser,
      selectedShow: state.startFrom === FUNNEL_CONSTANTS.START_FROM_OPTIONS.SHOW
    }),
    [FETCH_REFERRAL_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      referralTable: action.payload,
      isLeadSelected: true,
      startFromAppointment: false,
      filtersDirty: false
    }),
    [ADD_ALL_TIME_RANGE_SUCCESS]: (state, action) => ({
      ...state,
      rangeOptions: addAllTime(state, action)
    }),
    [FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS]: (state, action) => ({
      ...state,
      funnelIntroOffers: action.payload || state.funnelIntroOffers,
      isIntroOfferSelected: true,
      startFromAppointment: false,
      filtersDirty: false,
      averageIsNotSelected: state.average === "Not Selected",
      selectedShow: state.startFrom === FUNNEL_CONSTANTS.START_FROM_OPTIONS.SHOW
    }),
    [FETCH_SUB_AVERAGE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      subAverageFilterOptions: {
        Division: action.payload?.divisions || [],
        District: action.payload?.districts || [],
        Region: action.payload?.regions || []
      }
    })
  },
  initialState
);
